export const MODES = Object.freeze({
  football: {
    label: 'Football', event: 'TEAM SPRINT', billboard: 'FORTY / EVERY TAP COUNTS',
    headline: ['FORTY YARDS.', 'EVERYBODY IN.'], description: 'Your phone. Your team. Your moment.\nTap together. Take the finish line.',
    teams: [
      { name: 'VOLT', color: '#9dff43', hex: 0x9dff43, motto: 'BRING THE THUNDER', short: 'V', model: 'set3_02.glb' },
      { name: 'BLAZE', color: '#ff794d', hex: 0xff794d, motto: 'TURN UP THE HEAT', short: 'B', model: 'set3_02.glb' }
    ]
  },
  mgm: {
    label: 'MGM', event: 'PROPERTY SPRINT', billboard: 'LUXOR / MGM GRAND / EVERY TAP COUNTS',
    headline: ['THE STRIP.', 'ON THE LINE.'], description: 'Luxor versus MGM Grand.\nYour taps decide who takes Vegas.',
    teams: [
      { name: 'LUXOR', color: '#66e5fa', hex: 0x66e5fa, motto: 'LIGHT UP THE STRIP', short: 'LX', model: 'set4_01.glb' },
      { name: 'MGM GRAND', color: '#f7c86a', hex: 0xf7c86a, motto: 'BRING THE ROAR', short: 'MG', model: 'set3_05.glb' }
    ]
  }
});
export const isMode = mode => typeof mode === 'string' && Object.hasOwn(MODES, mode);
export const DEFAULT_MODE = 'mgm';
export const modeOf = mode => isMode(mode) ? mode : DEFAULT_MODE;
export const themeOf = mode => MODES[modeOf(mode)];
